module.exports = __webpack_public_path__ + "static/img/C (3).48b0293a.png";